import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Output, PLATFORM_ID } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-map-legend-modal',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './map-legend-modal.component.html',
})
export class MapLegendModalComponent {
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(@Inject(PLATFORM_ID) private platformId: string){}

  saveMapLegend(): void {
    this.closeModal.emit(true);
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('isMapLegendSetToTrue', true.toString());
    }
  }
}
